import React from 'react';
import { useInView } from 'react-intersection-observer';
import Counter from '../components/Counter';

export default function Stats() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const stats = [
    {
      value: 18,
      label: 'average increase in compensation',
      suffix: '%'
    },
    {
      value: 5000,
      label: 'interview coaching sessions conducted',
      suffix: ''
    },
    {
      value: 15000,
      label: 'hiring managers interviewed (we know what they look for)',
      suffix: ''
    },
    {
      value: 100000,
      label: 'resumes reviewed',
      suffix: ''
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">

        <div ref={ref} className="grid md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl font-bold text-blue-500 mb-2">
                {inView && <Counter end={stat.value} duration={2} />}{stat.suffix}
              </div>
              <p className="text-gray-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}